import { Component, Host, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'swc-usercentrics-cookie-banner',
  styleUrl: 'swc-usercentrics-cookie-banner.scss',
  shadow: false,
})
export class SwcUsercentricsCookieBanner {

  @Prop() serial: string;

  @Prop() loadPreview: string;

  @State() status: string;

  declare UC_UI: {
    showFirstLayer: () => void;
  };

  private loadCookieBannerTag(): void {

    document.querySelector('html').setAttribute('lang', 'de');
    const script = document.createElement('script');

    script.id = 'usercentrics-cmp';
    script.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';
    script.setAttribute('data-settings-id', this.serial);
    script.setAttribute('data-tcf-enabled', '');

    if (this.loadPreview === 'true') {
      script.setAttribute('data-version', 'preview');
    }

    document.head.appendChild(script);
    script.onload = () => {
      this.status = `Usercentrics script loaded successfully. ID:${this.serial}`;
    };

    script.onerror = () => {
      this.status = `Error loading the Usercentrics script. ID:${this.serial}`;
    };
  }

  openCookieBanner() {
    this.UC_UI.showFirstLayer();
  }

  componentDidLoad() {
    if (this.serial) {
      this.status = `Loading Usercentrics script. ID:${this.serial}...`;
      this.loadCookieBannerTag();
    }
  }

  render() {
    return (
      <Host>
        {this.status &&
          <div>
            {this.status}
          </div>
        }
      </Host>
    );
  }
}
